import { Platform } from 'react-native';

interface ShadowIOS {
    shadowColor: string;
    shadowOffset: {
        width: number;
        height: number;
    };
    shadowOpacity: number;
    shadowRadius: number;
}

interface ShadowAndroid {
    elevation: number;
}

export type ShadowStyle = ShadowIOS | ShadowAndroid;

export const Shadows = {
    SMALL: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: 3,
                },
                shadowOpacity: 0.03,
                shadowRadius: 6,
            },
            android: {
                elevation: 2,
            },
            web: {
                boxShadow: '0 3px 6px rgba(0, 0, 0, 0.03)',
            },
        }) as ShadowStyle),
    } as const,
    MEDIUM: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: 4.5,
                },
                shadowOpacity: 0.1,
                shadowRadius: 6,
            },
            android: {
                elevation: 3,
            },
            web: {
                boxShadow: '0 4.5px 9px rgba(0, 0, 0, 0.1)',
            },
        }) as ShadowStyle),
    } as const,
    LARGE: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: 6,
                },
                shadowOpacity: 0.15,
                shadowRadius: 6,
            },
            android: {
                elevation: 4,
            },
            web: {
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
            },
        }) as ShadowStyle),
    } as const,
    SMALL_TOP: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: -3,
                },
                shadowOpacity: 0.03,
                shadowRadius: 6,
            },
            android: {
                elevation: 2,
            },
            web: {
                boxShadow: '0 -3px 6px rgba(0, 0, 0, 0.03)',
            },
        }) as ShadowStyle),
    } as const,
    MEDIUM_TOP: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: -4.5,
                },
                shadowOpacity: 0.1,
                shadowRadius: 6,
            },
            android: {
                elevation: 3,
            },
            web: {
                boxShadow: '0 -4.5px 9px rgba(0, 0, 0, 0.1)',
            },
        }) as ShadowStyle),
    } as const,
    LARGE_TOP: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.05)',
                shadowOffset: {
                    width: 0,
                    height: -6,
                },
                shadowOpacity: 0.15,
                shadowRadius: 6,
            },
            android: {
                elevation: 4,
            },
            web: {
                boxShadow: '0 -6px 12px rgba(0, 0, 0, 0.15)',
            },
        }) as ShadowStyle),
    } as const,
    /** Conversational onboarding multi-select / composer cards (Figma Shadow + Blur Large). */
    CONVERSATIONAL: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(0, 0, 0, 0.06)',
                shadowOffset: {
                    width: 0,
                    height: 16,
                },
                shadowOpacity: 1,
                shadowRadius: 24,
            },
            android: {
                elevation: 8,
            },
            web: {
                boxShadow:
                    '0px 8px 8px 0px rgba(0, 0, 0, 0.02), 0px 16px 24px 0px rgba(0, 0, 0, 0.06)',
            },
        }) as ShadowStyle),
    } as const,
    RING: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(17, 17, 17, 0.07)',
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0.07,
                shadowRadius: 4,
            },
            android: {
                elevation: 2,
            },
            web: {
                boxShadow: '0 0 0 4px rgba(17, 17, 17, 0.07)',
            },
        }) as ShadowStyle),
    } as const,
    RING_ACTIVE: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(17, 17, 17, 0.17)',
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0.17,
                shadowRadius: 4,
            },
            android: {
                elevation: 1,
            },
            web: {
                boxShadow: '0 0 0 3px rgba(17, 17, 17, 0.17)',
            },
        }) as ShadowStyle),
    } as const,
    RING_SMALL: {
        ...(Platform.select({
            ios: {
                shadowColor: 'rgba(17, 17, 17, 0.07)',
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0.07,
                shadowRadius: 2,
            },
            android: {
                elevation: 1,
            },
            web: {
                boxShadow: '0 0 0 1px rgba(17, 17, 17, 0.07)',
            },
        }) as ShadowStyle),
    } as const,
};
